module.exports = __webpack_public_path__ + "static/img/Bitmap_server.8ad7d88.png";


//////////////////
// WEBPACK FOOTER
// ./static/Bitmap_server.png
// module id = XbyE
// module chunks = 3